<template>
  <router-link :to="{ name: 'ExamIndex' }">{{ bread }}</router-link>
</template>
<script>
export default {
  name: "ExamIndexBread",
  computed: {
    navigates() {
      return this.$store.state.navigates;
    },
    bread() {
      let nav = this.navigates.find(t => t.url == "/exam");
      if (nav) {
        return nav.label;
      }
      return "在线测评";
    },
  },
};
</script>
